"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfig = void 0;
const react_1 = __importDefault(require("react"));
const input_1 = __importDefault(require("@kyruus/input"));
const prop_types_1 = __importDefault(require("prop-types"));
const read_only_1 = __importDefault(require("../../read-only"));
const use_form_1 = __importDefault(require("../../../form/use-form"));
const styles_1 = require("../../../styles");
const TextInput = (props) => {
    const { path, label, disabled } = props;
    const eventProcessor = (e) => e.target.value;
    const [state, actions] = (0, use_form_1.default)(path, {
        eventProcessor
    });
    const { AddOn, config } = state;
    if (!config.isVisible)
        return null;
    if (config.isReadOnly) {
        return react_1.default.createElement(read_only_1.default, { msg: state.value });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.FieldFocusWrapper, { hasError: !!state.errors.length },
            react_1.default.createElement(input_1.default, { errors: state.errors, required: config.isRequired, onChange: actions.onChange, onBlur: actions.onBlur, value: state.value, placeholder: config.placeholder, disabled: config.isReadOnly || disabled, name: path, "data-testid": path, label: config.label || label || '', id: path, hideLabel: true, maxLength: config.maxLength, displayCharacterCount: config.displayCharacterCount, characterCountReachedMessage: config.characterCountReachedMessage, autoComplete: config.autoComplete })),
        react_1.default.createElement(AddOn, null)));
};
TextInput.propTypes = {
    path: prop_types_1.default.string.isRequired,
    label: prop_types_1.default.string,
    disabled: prop_types_1.default.bool
};
exports.default = TextInput;
exports.defaultConfig = {};
//# sourceMappingURL=index.js.map